import PathWrapper from "core/PathWrapper";

export const embeddedBase = new PathWrapper('embedded');